<template>
  <div>
    <div class="index-news">
      <div class="container">
          <div class="box clearfix">
              <div class="box-item">
                  <div class="inner titleChange">
                      <div class="title-box clearfix" style="background: #306BCD;height: 42px;">
                          <div class="list" style="    height: 42px;">
                              <img src="/static/img/kaui_yaowen.png" style="position: relative;top: -12px;"/>
                              <ul class="clearfix" style="height: 46px;position: relative;color: #fff;top: -56px;line-height: 54px;">
                                  <li class="active" style="color: #fff;font-size: 20px;font-weight: 600;"><img src="/static/img/icon_qiu.png" style="    position: relative;margin-right: 10px;top: 6px;"/>要闻播报</li>
                              </ul>
                          </div>
                          <div class="link">
                              <a href="http://www.bjrs.org.cn/list.aspx?m=66">
                                  <span style="color:#fff">查看更多&nbsp;&gt;&gt;</span>
                              </a>
                          </div>
                      </div>
                      <div class="newsList">
                          <!--学者论述-->
                          <div style="display:inline-block;height: 251px;background:rgb(241, 243, 249);">
                            <img src="/static/img/icon_yaowenbobao.png" />
                            <p style="    font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #333333;width: 199px;line-height: 25px;padding-left: 10px;padding-top: 10px;">{{Groups[0].articles[0].title}}</p>
                            <p style="    text-align: right;margin-top: 9px;margin-right: 10px;color: #999797;"><span style="    font-size: 15px;font-weight: 600;">{{getMonthDay(Groups[0].articles[0])}}</span><span style="">/{{getYear(Groups[0].articles[0])}}</span></p>
                          </div>
                          <div class="child" style="display: inline-block;width: 357px;margin-left: 15px;position: absolute;" v-if="Groups[0]">
                              <ul>
                                  <li class="clearfix newbefore" v-for="(article , index) in  Groups[0].articles" :key="index"><span class="date">{{article.addtime.slice(0,10)}}</span>
                                      <div class="title"><router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="box-item">
                 <img class="adv" src="/static/img/img_chuangxin.png">
                 <img class="adv" src="/static/img/img_fendou.png">
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
       Groups: [
        {
          name: "要闻播报", 
        }
      ],
    };
  },
  mounted() {
    let watchflag = 0;
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=7`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
   methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
    getMonthDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}-${now.getDate()}`;
    },
    getYearMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}-${now.getMonth() + 1}`;
    },
    getYear(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}`;
    },
  },
};
</script>
<style scoped>
@media screen and (min-width:480px) {
.xwscolf {
    width: 30%;
    float: left;
    height: auto;
    
}

.xwscolfc {
    width:  30%;
    float: left;
    height: auto;
    margin-left:5%;
}

.xwscolfr {
    width:  30%;
    float: right;
    height: auto;
}
/deep/ .el-card__body{
      padding: 25px;
}
}
.Inqclss{
    font-size: 33px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
}
@media screen and (max-width:480px) {
  .xwscolf {
      width: 92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfc {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfr {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }
  /deep/ .el-card__body{
      padding: 10px;
  }
  .Inqclss{
    font-size: 28px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
  }
}



/deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
  box-shadow: 0 2px 12px 0 rgb(206 26 18);
}
/deep/ .el-card{
  border: 1px solid #ce1a12;
}
.index-news .box-item{
  width: 50%;
}
.box-item .adv{
      width: 577px;
    height: 152px;
    margin-left: 39px;
    margin-bottom: 37px;
}
</style>
